import { Chip, useTheme } from "@mui/material";

const CardChip = ({ label, color, borderColor }) => {
	const theme = useTheme()
	return (
		<Chip
			label={label}
			sx={{
				color: color ? `#${color}` : theme.palette.info.main,
				borderColor: borderColor ? `#${borderColor}` : theme.palette.info.main
			}}
			size={"small"}
			variant={'outlined'}
		/>
	);
};

export default CardChip